module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter6"
    }
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "href": "#/003toc#ch6"
    }
  }, [_vm._v("Shiitake Mushroom Miso Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Miso soup is not only good for you but also terrific for a warm-up on a cold day. This soup is enriched with bok choy and shiitake mushrooms, making it a hearty vegetable soup to serve anytime.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 tablespoons vegetable oil")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 clove garlic, minced")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 teaspoon freshly grated ginger")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("8 ounces shiitake mushrooms, stems removed, caps sliced")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("4 small baby bok choy, stem ends removed and chopped into ½-inch pieces (see savvy)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("¼ cup light miso paste (see savvy)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("6 cups vegetable or chicken broth")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 teaspoons soy sauce")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("6 green onions, finely chopped using the white and tender green parts")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 pound firm tofu, drained and cut into")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("½-inch cubes")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("heat the oil in a medium skillet over medium-high heat.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("add the garlic and ginger and sauté, about 1 minute until fragrant. Add the mushrooms and toss to combine.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("transfer the contents of the skillet to the insert of a 5-quart slow cooker and add the bok choy. Stir in the miso paste, broth, and soy sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("cover the slow cooker and cook on high for 2½ to 3 hours.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("remove the cover and stir in the green onions and tofu.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("serve the soup from the slow cooker.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Serves 6–8")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "sidebar_head"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "image 1",
      "src": "images/image-01.jpg"
    }
  }), _vm._v("bok choy savvy")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If bok choy is very expensive, as it can be, chopped napa cabbage may be substituted. You should have about 2 cups.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("miso savvy")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Miso is found in the Asian section of your supermarket.")])]), _vm._v(" "), _c('p', {
    staticClass: "breakhere"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-179e6ef7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/012-chapter6.vue
// module id = 90
// module chunks = 0